
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {}
})
export default class SettingsSwitch extends Vue {
  @Prop({ required: true }) active: boolean

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
